import { useTableState } from '../../Table/useTableState/useTableState';
import { ListPreference } from './';

/**
 * The List persistence hook.
 */
export const useListState = (listPreference?: ListPreference) => {
  const {
    preference: tablePreference,
    dispatch,
    setFreezeColumn,
    setOrderedColumnKeys,
    setResizedColumn,
    setFreezeColumnCount,
    ...listState
  } = useTableState(listPreference);
  const { frozenColumnCount, resizedColumns, orderedColumnKeys, ...preference } = tablePreference;
  return { preference, ...listState };
};
